/**  Класс для сообщения из чата */
export class ChatMeassagesData {
  /** текст. */
  public Text: string = "";

  /** дата и время. */
  public DateTime: any = Date.now();

  /** */
  public BankMessage: boolean = false;


  /**
   * Конструктор с загрузкой данных из ответа сервера.
   * @param src данные с сервера
   */
  constructor(src: any) {
    if (src) {
      this.Text = src.Text ?? '';
      this.DateTime = src.Date ?? Date.now;
      this.BankMessage = src.FromBank ?? false;
    }
  }
}
